import { V_TYPE_ARRAY, V_TYPE_OBJECT } from 'app-constants/variableTypes';

export const isJson = (str) => {
  try {
    JSON.parse(str);
  } catch {
    return false;
  }
  return true;
};

export const formatValue = (type, value) => {
  if (type === V_TYPE_OBJECT || type === V_TYPE_ARRAY) {
    if (typeof value === 'object' || isJson(value)) {
      return JSON.stringify(value, undefined, 2);
    }
  }
  return String(value);
};
